document.addEventListener('DOMContentLoaded', () => {
  const updateColorSwatchesTabindex = () => {
    const colorFamilyEls = Array.from(document.querySelectorAll('.js-color-family'))

    colorFamilyEls.forEach(el => {
      const inputEls = Array.from(el.querySelectorAll('input'))

      if (inputEls.length <= 0) return

      // Remove id for all input elements, except the last one
      inputEls.forEach((input, index) => {
        if (index !== inputEls.length - 1) {
          input.removeAttribute('id')
        }
      })

      inputEls[inputEls.length - 1].setAttribute('tabindex', '0')
    })
  }

  updateColorSwatchesTabindex()
  document.addEventListener('theme:loading:end', updateColorSwatchesTabindex)
})
